/**
 * @graphql agg
 */
import { graphql } from 'react-relay';

export const ConfluenceFreePoolTargetExperimentQuery = graphql`
	query ConfluenceFreePoolTargetExperimentQuery($cloudId: ID!, $productKey: String!) {
		tenantContexts(cloudIds: [$cloudId]) {
			entitlementInfo(hamsProductKey: $productKey) {
				entitlement {
					entitlementProfile {
						paidFeatureUsage {
							featureName
						}
						trialHistory {
							trialType
						}
					}
					latestUsageForChargeElement(chargeElement: "user")
					preDunning {
						status
					}
					transactionAccount {
						isBillToPresent
					}
					subscription {
						trial {
							timeLeft
						}
					}
					... on CcpEntitlement {
						createdAt
					}
					experienceCapabilities {
						changeOfferingV2(offeringName: "standard") {
							isAvailableToUser
							experienceUrl
						}
					}
				}
			}
		}
	}
`;
